module.exports = __webpack_public_path__ + "img/bone.6ab393a3.svg";